import { put, takeLatest, call } from 'redux-saga/effects';
import * as type from '../action-types';
import { fetchProjectcategories } from '../apis/projectApi';

function* getProjectcategories(action) {
	try {
    const data = yield call(fetchProjectcategories);
    yield put({
      type: type.GET_PROJECT_CATEGORIES_SUCCESS,
      payload: data
    });
  } catch ({ message }) {
    yield put({
      type: type.GET_PROJECT_CATEGORIES_FAILURE,
      payload: message
    });
  }
}

export function* getProjectCategoriesActionWatcher() {
  yield takeLatest(type.GET_PROJECT_CATEGORIES, getProjectcategories);
}
